import { type AdminGigsterProfilesListParams, getAdminGigsterProfilesListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminGigsterProfilesListParams };

export const prosQuery = ({ search }: QueriesInput) => getAdminGigsterProfilesListQueryOptions(search);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [prosQuery(input)];
